import React from 'react';
import { AtdwMap } from '../atdw-map/view/atdwMap';

export const renderRule = {
  match: (item, cmsOption) => item.itemTypeCode === 'AtdwMapTown', 
  itemElt: (item, cmsOption) => <AtdwMap item={item} cmsOption={cmsOption} fromType = {"town"} />
}